// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3bN2Q","header":"MessagesList_header__3XM2Y","chat":"MessagesList_chat__ECcw8"};